import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';

import { ConfigsService as GeneralConfigService } from '@sm360/widget-commons-core-services';

import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import * as actions from 'inventory-listing/actions/listingUsedActions.js';
import VehicleCriteriaModel from 'inventory-listing/models/VehicleCriteriaModel';

const QUERY_USED = gql`
    query fetchVehicleFilters($organizationUnitId: Int!, $vehicleCriteria: VehicleCriteria) {
        searchVehicles(first: 1, organizationUnitId: $organizationUnitId, vehicleCriteria: $vehicleCriteria) {
            metadataCategories {
                name
                metadatas {
                    code
                    label
                }
            }
        }
    }
`;

const QUERY_NEW = gql`
    query fetchNewVehicleFilters($organizationUnitId: Int!, $newVehicleCriteria: NewVehicleCriteria) {
        searchNewVehicles(first: 1, organizationUnitId: $organizationUnitId, newVehicleCriteria: $newVehicleCriteria) {
            metadataCategories {
                name
                metadatas {
                    code
                    label
                }
            }
        }
    }
`;

function getOptions({ isListingNew, vehicleCriteria }) {
    const criteria = vehicleCriteria || new VehicleCriteriaModel();

    const variables = {
        organizationUnitId: GeneralConfigService.getOrganizationUnitId(),
        [isListingNew ? 'newVehicleCriteria' : 'vehicleCriteria']: {
            ...criteria.mapToLimitedMandatoryPropertySetObject(),
            onlyBuiltVehicles: isListingNew ? criteria.onlyBuiltVehicles : false,
        },
    };

    return { variables };
}

function getProps(props) {
    const { data } = props;
    let metadataCategories = [];

    let result = null;
    if (data && data.searchNewVehicles) {
        result = data.searchNewVehicles;
    }
    if (data && data.searchVehicles) {
        result = data.searchVehicles;
    }

    if (result) {
        const { loading } = data;

        if (!loading && result && result.metadataCategories) {
            metadataCategories = result.metadataCategories.map((metadataCategory) => {
                let metadatas = [];
                if (metadataCategory && metadataCategory.metadatas) {
                    metadatas = metadataCategory.metadatas.map((metadata) => new MetaDataModel(metadata));
                }
                return {
                    ...metadataCategory,
                    metadatas,
                };
            });
        }
    }

    return {
        metadataCategories,
    };
}

const filtersForListingNew = graphql(QUERY_NEW, {
    alias: 'filtersForListingNew',
    options: getOptions,
    props: getProps,
    skip: (props) => !props.isListingNew,
});

const filtersForListingUsed = graphql(QUERY_USED, {
    alias: 'filtersForListingUsed',
    options: getOptions,
    props: getProps,
    skip: (props) => props.isListingNew,
});

function mapStateToProps(state) {
    return {
        vehicleCriteria: state.listingUsed.vehicleCriteria,
        isListingNew: state.listingUsed.colanderGroupIsNew(),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    };
}

const reduxContainer = connect(
    mapStateToProps,
    mapDispatchToProps
);

export default compose(
    reduxContainer,
    filtersForListingNew,
    filtersForListingUsed
);



// WEBPACK FOOTER //
// ./client/src/components/ListingFilters/ListingFiltersContainer.js